import { useState, useEffect } from "react";

const useDebounce = (data) => {
  const [input, setInput] = useState(null);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setInput(data);
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [data]);

  return input;
};

export default useDebounce;
